import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqItems } from "../../data/faq";
import { company } from "../../data/navigation";
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white py-20 md:py-28" data-id="element-94" data-mp="2a2pirs0ri14m">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 md:px-8 lg:grid-cols-12" data-id="element-95" data-mp="1v6gkotslxtts">
        <div className="lg:col-span-4" data-id="element-96" data-mp="1v8l0oa3s6jaf">
          <h2 className="text-4xl font-semibold leading-[1.05] tracking-tight text-ink md:text-5xl" data-id="element-97" data-mp="20631fd7n9s7c">
            Questions fréquentes
          </h2>
          <p className="mt-5 leading-relaxed text-muted" data-id="element-98" data-mp="1m7mvvpliq7qs">
            Vous ne trouvez pas votre réponse ? Appelez-nous au{" "}
            <a href={company.phoneHref} className="font-medium text-ink underline underline-offset-4" data-id="element-99" data-mp="3gjtdp78x3ms2">
              {company.phone}
            </a>
            .
          </p>
        </div>

        <ul className="divide-y divide-ink/10 border-y border-ink/10 lg:col-span-8" data-id="element-100" data-mp="3lgjszscweecf">
          {faqItems.map((item, i) => {
          const isOpen = openIndex === i;
          const id = `faq-${i}`;
          return <li key={item.question} data-id="element-101" data-mp="2x6acu17t9ozo" data-mpi={i}>
                <h3 data-id="element-102" data-mp="2x4z6puqw855e">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={id} className="flex w-full items-center justify-between gap-6 py-6 text-left text-lg font-semibold text-ink md:text-xl" data-id="element-103" data-mp="2x7lenvhp4mo5">
                    {item.question}
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? "bg-lime" : "bg-paper"}`} data-id="element-104" data-mp="2ecwoieylsgt1">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-105" data-mp="3kutlwiyoq5st" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-106" data-mp="aq60urea2y4v">
                  {isOpen && <motion.div id={id} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-107" data-mp="ao1y4cs48566">
                      <p className="max-w-2xl pb-6 leading-relaxed text-muted" data-id="element-108" data-mp="3nz0wnfcqab61">{item.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}